<template>
	<div class="page-main">
		<div class="app-head">
			<nav-bar :left-arrow="true" title="详情" @click-left="back" />
		</div>

		<div ref="scrollDom" style="flex: 1; min-height: 1px">
			<div>
				<div v-if="info" class="order-top">
					<div class="left">
						<div class="time">
							<img class="icon" src="~@/assets/b.jpg" />
							{{ info.createTime | getTime }}
						</div>
						<div class="address">
							{{ info.storeName }}-{{ info.storeAddress }}
						</div>
					</div>

					<a class="tel" :href="'tel:'+info.storePhone">
						<img class="icon" src="~@/assets/tel.jpg" />
					</a>
				</div>

				<div v-if="info" class="product-warp">
					<div v-for="(item, index) in info.products" :key="index" class="product-item">
						<div class="left-img">
							<span></span>
							<img :src="item.defaultImage" />
						</div>
						<div class="right-content">
							<div class="name">
								<span class="text">{{ item.name }}</span>
								<span class="price"><span>￥</span>{{ item.price / 100 }}</span>
							</div>
							<ul class="extra-list">
								<li>
									<span class="extra">{{ item.specName }}</span>
									<span class="fr">￥{{ item.price / 100 }}</span>
								</li>
								<li v-for="(extra, index) in item.addExtra" class="extra" :key="index">
									<span>{{ extra.name }}</span>
								</li>
								<li v-for="(coupon, index) in item.coupons" class="coupon" :key="index">
									<span>{{ coupon.couponName }}</span>
									<span class="fr">-￥{{coupon.discountAmount/100}}</span>
								</li>

							</ul>
						</div>
					</div>

					<div class="order-info">
						<div class="info-item">
							<div class="left">产品小计</div>
							<div class="dian"></div>
							<div class="right">
								<span>￥</span>{{ info.productPrice / 100 }}
							</div>
						</div>

						<div class="info-item green" v-for="(item, index) in info.bff_discount_info" :key="index">
							<div class="left">{{ item.title }}</div>
							<div class="dian"></div>
							<div class="right">-<span>￥</span>{{ item.value / 100 }}</div>
						</div>

						<div class="info-item">
							<div class="left" style="font-weight: bold">总计</div>
							<div class="dian"></div>
							<div class="right">
								<span>￥</span>{{ info.totalPrice / 100 }}
							</div>
						</div>
					</div>
				</div>

				<div class="store-wrap">
					<div class="name" style="font-weight: bold; font-size:17px;">{{ info.storeName }}</div>
					<div class="address">
						<div class="tel">
							<a :href="'tel:'+info.storePhone">
								<span class="icon"></span>
								联系门店
							</a>
						</div>
						<div class="text text-ellipsis">{{ info.storeAddress }}</div>
					</div>
				</div>
				<div v-if="info" class="order-info">
					<div class="info-item">
						<div class="left">订单号</div>
						<div class="dian"></div>
						<div class="right">
							{{ info.id }}
							<span class="copy" v-clipboard:error="onError" v-clipboard:copy=" info.id"
								v-clipboard:success="onCopy">复制</span>
						</div>
					</div>

					<div class="info-item">
						<div class="left" style="font-weight: bold; transform: scale(1)">
							支付方式
						</div>
						<div class="dian"></div>
						<div class="right">
							{{ info.pay_way_str }}
						</div>
					</div>

					<div class="info-item">
						<div class="left">下单时间</div>
						<div class="dian"></div>
						<div class="right">
							{{ info.createTime | getTime }}
						</div>
					</div>

					<div class="info-item" v-if="info.order_status_str==='已完成'">
						<div class="left">取单/完成时间</div>
						<div class="dian"></div>
						<div class="right">
							{{ info.finishTime | getTime }}
						</div>
					</div>

					<div class="info-item">
						<div class="left">订单状态</div>
						<div class="dian"></div>
						<div class="right">
							{{ info.order_status_str }}
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import {
		NavBar
	} from "vant";
	import {
		orderDetails
	} from "@/api";
	import BScroll from "@better-scroll/core";

	export default {
		components: {
			NavBar,
		},
		created() {
			this.orderId = this.$route.query.id;
			orderDetails(this.orderId).then((d) => {
				this.info = d.data;

				this.$nextTick(() => {
					this.leftScroll = BScroll(this.$refs["scrollDom"], {
						click: true,
					});
				});
			});
		},
		data() {
			return {
				info: null,
				orderId: null,
			};
		},
		methods: {
			back() {
				this.$router.back();
			},
			onCopy() {
				this.$msg("口令已复制");
			},
			onError() {
				this.$msg("您的设备暂不支付复制");
			},
		},
		filters: {
			getTime(v) {
				var str = v.replaceAll("-", "/")
				var time = new Date(str);

				var Y = time.getFullYear();
				var M = time.getMonth() + 1;
				var D = time.getDate();

				var h = time.getHours();
				var m = time.getMinutes();

				var t = "" + (h >= 12 ? "下午 " : "上午 ");

				if (h > 12) {
					h = h - 12;
				}

				h = (h < 10 ? "0" : "") + h;
				m = (m < 10 ? "0" : "") + m;

				return `${Y}年${M}月${D}日 ${t} ${h}:${m}`;
			},
		},
	};
</script>

<style lang="scss" scoped>
	::v-deep .van-nav-bar .van-icon {
		color: #333 !important;
	}

	.page-main {
		position: relative;
		height: 100vh;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		background: #f1f1f1;
	}

	.order-top {
		background: #ffffff;
		display: flex;
		padding: 30px 40px 30px 30px;
		align-items: center;

		.left {
			flex: 1;

			.time {
				font-size: 30px;
				display: flex;
				align-items: center;
				margin-bottom: 10px;

				.icon {
					width: 50px;
					height: 50px;
					margin-right: 10px;
				}
			}
		}

		.tel {
			width: 60px;
			margin-left: 60px;

			img {
				width: 100%;
				display: block;
			}
		}

		.address {
			color: #666;
			font-size: 24px;

		}
	}

	.product-warp {
		background: #f7f7f7;

		.product-item {
			display: flex;
			padding: 0 50px 0 30px;
		}

		.left-img {
			width: 120px;
			height: 120px;
			position: relative;
			margin-right: 30px;
			margin-top: 10px;

			&>* {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
			}

			&>img {
				object-fit: contain;
			}

			&>span {
				width: 100%;
				height: 100%;
				left: 50%;
				top: 50%;
				background: rgb(216, 219, 60);
				border-radius: 50%;
				transform: translate(-50%, -50%) scale(0.82);
			}
		}

		.right-content {
			flex: 1;
			min-width: 0;
			padding: 20px 0;

			.name {
				font-size: 32px;
				margin-bottom: 4px;
				display: flex;

				.text {
					flex: 1;
					min-width: 0;
				}

				.price {
					font-weight: bold;

					span {
						font-size: 28px;
					}
				}
			}

			.extra-list {
				font-size: 25px;
				color: #666;

				li {
					height: 30px;



					span {
						display: inline-block;
						transform: scale(0.83);
						transform-origin: left;

						&.fr {
							transform-origin: right;
						}
					}
				}
			}
		}

		.order-info {
			margin-left: 70px;

			.left {
				transform: scale(1) !important;
				font-size: 26px !important;
			}

			.right span {
				font-size: 20px;
			}
		}
	}

	.order-info {
		padding: 30px 40px 30px 20px;

		.info-item {
			display: flex;

			&+.info-item {
				margin-top: 16px;
			}

			.left {
				text-align: right;
				width: 180px;
				font-size: 24px;
				transform: scale(0.92);
				transform-origin: right;
			}

			.dian {
				margin: 0 12px;
				height: 0.9em;
				flex: 1;
				border-bottom: 1px dotted #999;
			}

			.right {
				font-weight: bold;
				font-size: 26px;
			}

			.copy {
				color: #07c160;
				margin-left: 16px;
				padding-left: 16px;
				border-left: 1px solid #999;
			}
		}
	}

	.store-wrap {
		text-align: right;
		padding: 30px 40px 10px;

		.name {
			font-size: 30px;
			margin-bottom: 10px;
		}

		.address {
			display: flex;
			line-height: 1;

			.tel {
				color: #666;
				flex: 1;
				margin-right: 16px;
				padding-right: 16px;
				border-right: 1px solid #ddd;

				.icon {
					background: url(~@/assets/tel2.jpg);
					background-repeat: no-repeat;
					width: 30px;
					height: 30px;
					display: inline-block;
					background-size: contain;
					vertical-align: middle;
				}
			}

			.text {
				max-width: 440px;
			}
		}
	}

	.coupon {
		color: #35845B;
		font-weight: bold;




	}

	.extra {
		font-weight: normal;

	}

	.green {
		color: #35845B;
	}
</style>